import React, { useEffect, useState } from 'react';
import './Toast.css';

export default function Toast({ type = 'success', message, onClose }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (message) {
      setVisible(true);
      const t = setTimeout(() => {
        setVisible(false);
        setTimeout(() => onClose?.(), 250);
      }, 3000);
      return () => clearTimeout(t);
    }
  }, [message, onClose]);

  if (!message) return null;

  return (
    <div
      className={`Toast Toast-${type} ${visible ? 'Toast-visible' : ''}`}
      role="status"
      aria-live="polite"
    >
      <span className="Toast-icon">
        {type === 'success' ? '✅' : type === 'error' ? '⚠️' : 'ℹ️'}
      </span>
      <span className="Toast-message">{message}</span>
      <button
        className="Toast-close"
        onClick={() => {
          setVisible(false);
          setTimeout(() => onClose?.(), 250);
        }}
        aria-label="Close"
      >
        ✕
      </button>
    </div>
  );
}